export function slugify(text) {
  if (!text) {
    return "event";
  }
  return String(text)
    .toLowerCase()
    .trim()
    .replace(/[^\w\s-]/g, "")
    .replace(/[\s_-]+/g, "-")
    .replace(/^-+|-+$/g, "") || "event";
}

export function getEventPath(id, title) {
  return `/events/${slugify(title)}/${id}`;
}

export function getEventIdFromMatch(match) {
  return match && match.params ? match.params.id : null;
}
